/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.4.0
 */

import styled from 'styled-components';

import { checkbox } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';

export interface IStyledProps extends IAttrStyled {
    kind: string;
}

const RadioButtonContainerStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `checkbox ${className || ''}`,
}))<IStyledProps>`
    display: flex;
    align-items: center;
    position: relative;
    min-width: 20px;
    height: 20px;
    outline: none;
    line-height: 1.4;
    > input {
        opacity: 0;
        position: absolute;
    }
    > label {
        padding-left: 32px;
    }
    > input + label {
        cursor: pointer;
        box-sizing: border-box;
        &:before { /* Border and background color*/
            content: '';
            position: absolute;
            left:0;
            top: 0;
            width: 16px;
            height: 16px;
            border-radius: 2em;
            border: solid 2px ${checkbox.borderColor};
            background-color: ${checkbox.bgColor}
            box-sizing: border-box;
        }
        &:after { /* Checked state */
            content: ' ';
            position: absolute;
            font-size: 16px;
            transition: all .2s;
            background-color: white;
            top: 6px;
            left: 6px;
            width: 8px;
            height: 8px;
            border-radius: 4px;
        }
    }
    > input:not(:checked) + label {
        &:after { /* Checked icon don't display */
        opacity: 0;
        transform: scale(0);
    }
    }
    > input:not(:checked) + label:hover {
        &:before { /* Border and background color for hover state */
            box-shadow: none;
            border-color: ${checkbox.borderColorHover};
        }
    }
    > input:not(:checked) + label:active {
        &:before { /* Border and background color for hover state */
            box-shadow: none;
            border-color: ${checkbox.borderColorDown};
        }
    }
    > input:disabled:not(:checked) + label {
        &:before { /* Border and background color for disable state */
            box-shadow: none;
            border-color: ${checkbox.borderColor};
            background-color: ${checkbox.bgColorDisable};
            cursor: default;
        }
    }
    > input:checked + label {
        &:after {  /* Checked icon display */
            opacity: 1;
            transform: scale(1);
        }
        &:before { /* Border and background color for checked state */
            border: solid 2px ${checkbox.borderColorChecked};
            background-color: ${checkbox.bgColorChecked};
        }
    }
    > input:checked + label:hover {
        &:before {    /* Border and background color for checked and hover state */
            box-shadow: none;
            border-color: ${checkbox.borderColorCheckedHover};
            background-color: ${checkbox.bgColorCheckedHover};
        }
    }
    > input:checked + label:active {
        &:before {    /* Border and background color for checked and disabled state */
            box-shadow: none;
            border-color: ${checkbox.borderColorDown};
            background-color: ${checkbox.bgColorCheckedDown};
        }
    }
    > input:disabled:checked + label {
        cursor: default;
        &:before {    /* Border and background color for checked and disabled state */
            box-shadow: none;
            border-color: ${checkbox.borderColor};
            background-color: ${checkbox.bgColorCheckedDisable};
            cursor: default;
        }
    }
`;

export {
    RadioButtonContainerStyled,
}
